<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="update-checklist-modal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">Update Checklist</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="!formFlag  && !loading" class="modal-body">
            <section v-if="!moveTasksFlag && !previewFlag">
              <div class="row">
                <div class="col-md-12">
                  <button class="btn btn-sm btn-primary pull-right " @click="showMoveTasks()">Move Task</button>
                  <button class="btn btn-sm btn-primary pull-left" @click="previewFlag = true">Preview</button>
                </div>
              </div>
              <section v-for="(phase, p_index) of checklist" :key="p_index">
                <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>Task</th>
                      <th>Migration</th>
                      <th>Review</th>
                      <th>Required</th>
                      <th class="w-170">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td colspan="2">
                        <h6 class="text-danger pull-left">Phase {{ p_index +1 }}</h6>
                      </td>
                      <td  class="w-170" colspan="3">
                        <button class="btn btn-sm btn-primary pull-right" @click="addTask(phase)"><i class="fa fa-plus"></i></button>
                      </td>
                    </tr>
                    <tr v-for="(task, task_index) of phase.tasks" :key="'tasks_' + task_index">
                      <td v-if="!task.heading" :style="(task.pl) ? 'padding-left: 50px  !important;' : ''">
                        <span v-html="task.text.replace(/\n/g, '<br>')"></span>
                      </td>
                      <td v-else colspan="2">
                        <b v-html="task.text"></b>
                      </td>
                      <td v-if="!task.heading">
                        <div v-if="!task.heading" class="custom-control custom-checkbox">
                          <input type="checkbox" v-model="task.migration" required @change="updateChecklist" class="custom-control-input" :id="'p' + p_index + 't' + task_index + 'migration'"/>
                          <label class="custom-control-label pt-1" :for="'p' + p_index + 't' + task_index + 'migration'"></label>
                        </div>
                      </td>
                      <td v-if="!task.heading">
                        <div v-if="!task.heading" class="custom-control custom-checkbox">
                          <input type="checkbox" v-model="task.review" required @change="updateChecklist" class="custom-control-input" :id="'p' + p_index + 't' + task_index + 'review'"/>
                          <label class="custom-control-label pt-1" :for="'p' + p_index + 't' + task_index + 'review'"></label>
                        </div>
                      </td>
                      <td v-if="!task.heading">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" v-model="task.required" required @change="updateChecklist" class="custom-control-input" :id="'p' + p_index + 't' + task_index + 'required'"/>
                          <label class="custom-control-label pt-1" :for="'p' + p_index + 't' + task_index + 'required'"></label>
                        </div>
                      </td>
                      <td class="w-170" :colspan="(task.heading) ? '3' :''">
                        <div class="pull-right">
                          <button class="btn btn-sm btn-danger pull-right " @click="deleteTask(phase, task_index)"><i class="fa fa-trash"></i></button>
                          <button class="btn btn-sm btn-primary mr-2 pull-right" @click="editTask(phase, task_index)"><i class="fa fa-pencil"></i></button>
                          <button v-if="task.heading" class="btn btn-sm btn-primary mr-2" @click="addTask(phase, task_index)"><i class="fa fa-plus"></i></button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
              </section>
            </section>
            <section v-if="moveTasksFlag">
              <div class="row">
                <div class="col-md-12">
                  <button type="button" class="btn btn-default btn-sm pull-left" @click="viewChecklist">Back</button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>Select Phase:</label>
                  <select class="form-control col-md-6" v-model="movePhaseIndex">
                    <option v-for="p in phaseCount" :value="p - 1" :key="p - 1">{{'Phase ' + p}}</option>
                  </select>
                </div>
              </div>
              <div class="row mt-3" v-if="movePhaseIndex !== null">
                <div class="col-md-12">
                  <b>Select Task to move</b>
                  <table class="table table-hover mt-3">
                    <tr v-for="(task,index) of selectedPhase.tasks" :key="index">
<!--                      <td>-->
<!--                        <span v-html="task.text"></span>-->
<!--                      </td>-->
                      <td v-if="!task.heading" :style="(task.pl) ? 'padding-left: 50px  !important;' : ''">
                        <span v-html="task.text.replace(/\n/g, '<br>')"></span>
                      </td>
                      <td v-else colspan="2">
                        <b v-html="task.text"></b>
                      </td>
                      <td v-if="!task.heading">
                        <button v-if="selectedTaskIndex === null" type="button" class="btn btn-primary btn-sm pull-right" @click="selectTasksToMove(index)">Select</button>
                        <button v-else type="button" class="btn btn-success btn-sm pull-right" @click="moveTasksIndex(index)">Move befroe</button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </section>
            <section v-if="previewFlag">
              <div class="row">
                <div class="col-md-12">
                  <button type="button" class="btn btn-default btn-sm pull-left" @click="previewFlag = false">Back</button>
                </div>
              </div>
              <section v-for="(phase, p_index) of checklist" :key="p_index">
                <table class="table table-hover">
                    <thead v-if="p_index === 0">
                    <tr>
                      <th>Task</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>
                        <h6 class="text-danger pull-left">Phase {{ p_index +1 }}</h6>
                      </td>
                    </tr>
                    <tr v-for="(task, task_index) of phase.tasks" :key="'tasks_' + task_index">
                      <td v-if="!task.heading" :style="(task.pl) ? 'padding-left: 50px  !important;' : ''">
                        <template v-if="task.type === 'dropdown'">
                          <select class="form-control col-md-6">
                            <option v-for="(opt, d_index) of getDropdownOption(task.text)" :value="opt" :key="d_index">{{opt}}</option>
                          </select>
                        </template>
                        <template v-else>
                          <span v-if="task.text.toLowerCase().includes('cloudflare') && task.text.toLowerCase().includes('pause')" class=" cf-status-icons pull-right">
                            <a  href="javascript:void(0)" class="mx-2">
                               <i title="SSL - FULL" class="fa fa-lock mr-3 yellow"></i></a>
                            <a  href="javascript:void(0)" class="mx-2">
                              <i title="CF - Active & Un-Paused" class="my-3 fa fa-cloud enabled"></i>
                            </a>
                           </span>
                          <span v-html="task.text.replace(/\n/g, '<br>')"></span>
                          <span v-if="task.text.toLowerCase().includes('wpo') && task.text.toLowerCase().includes('ftp') && task.text.toLowerCase().includes('php') && task.text.toLowerCase().includes('cloudflare') && task.text.toLowerCase().includes('backup')">
                           <a href="javascript:void(0)" class="btn btn-sm btn-primary">
                             View Account
                           </a>
                         </span>
                        </template>
                      </td>
                      <td v-else colspan="2">
                        <template>
                          <b v-html="task.text"></b>
                        </template>
                      </td>
                    </tr>
                    </tbody>
              </table>
              </section>
            </section>
          </div>
          <div v-if="formFlag && !loading" class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-sm btn-primary"  @click="addMacro(' {domainName}')">Domain Name</button>
              </div>
            </div>
            <form @submit.prevent="submit">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-check-radio">
                    <label class="form-check-label">
                      <input class="form-check-input" v-model="newTask.type" @click="changeTask()" type="radio" name="taskType" id="task" value="normal"> New Task
                      <span class="form-check-sign"></span>
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check-radio">
                    <label class="form-check-label">
                      <input class="form-check-input" v-model="newTask.type"  @click="changeTask()"  type="radio" name="taskType" id="t_heading" value="heading"> Heading
                      <span class="form-check-sign"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="newTask.type === 'normal'" class="row">
                <div class="col-md-12">
                  <hr>
                  <label>Task Type:</label>
                </div>
              </div>
              <div v-if="newTask.type === 'normal'" class="row">
                <div class="col-md-4">
                  <div class="form-check-radio">
                    <label class="form-check-label">
                      <input class="form-check-input" v-model="newTask.answerType" @click="changeAnswerType()" type="radio" name="answerType" id="simple" value="simple"> Simple
                      <span class="form-check-sign"></span>
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check-radio">
                    <label class="form-check-label">
                      <input class="form-check-input" v-model="newTask.answerType" @click="changeAnswerType()" type="radio" name="answerType" id="dropdown" value="dropdown"> Dropdown
                      <span class="form-check-sign"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="newTask.answerType !== 'dropdown'" class="form-group">
                <label>Text</label>
                <vue-editor v-model="newTask.text" :editor-toolbar="customToolbar" />
                <h5 class="mt-3 mb-0" v-if="newTask.text && newTask.text !== ''">Preview</h5>
                <div v-html="newTask.text"></div>
              </div>
              <div v-else class="form-group">
                <label>Options (separated by new line):</label>
                <textarea class="form-control" required rows="3" v-model="newTask.text"></textarea>
              </div>
              <button type="submit" class="btn btn-primary pull-right">Submit</button>
              <button type="button" class="btn btn-default pull-left" @click="viewChecklist">Back</button>
            </form>
          </div>
          <div v-if="loading" class="modal-body">
            <div class="loader"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init"
import { VueEditor } from "vue2-editor";
import swal from "sweetalert2";
export default {
  name: "updateChecklistModal",
  components: {
    VueEditor
  },
  props: {
    checklist: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      selectedTask: null,
      loading: false,
      formFlag: false,
      moveTasksFlag: false,
      previewFlag: false,
      movePhaseIndex: null,
      selectedTaskIndex: null,
      newTask: {
        type: 'normal',
        answerType: 'simple',
        text: ''
      },
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ script: "sub" }, { script: "super" }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"]
      ]
    }
  },
  computed: {
    phaseCount () {
      return this.checklist.length
    },
    selectedPhase () {
      return (this.movePhaseIndex !== null) ? this.checklist[this.movePhaseIndex] : {}
    }
  },
  methods: {
    addMacro (macro) {
      this.newTask.text += macro
    },
    selectTasksToMove (index) {
      this.selectedTaskIndex = index
      this.selectedTask = this.selectedPhase.tasks[index]
      this.selectedPhase.tasks.splice(index, 1)
    },
    getDropdownOption (text) {
      return text.split('\n')
    },
    moveTasksIndex (index) {
      this.selectedPhase.tasks.splice(index, 0, this.selectedTask)
      this.selectedTaskIndex = null
      this.selectedTask = null
      this.updateChecklist ()
    },
    showMoveTasks () {
      this.moveTasksFlag = true
    },
    changeTask () {
      this.newTask.answerType = 'simple';
    },
    changeAnswerType () {
      this.newTask.text = ''
    },
    async deleteTask (phase, t_index) {
      const result = await swal({
        title: "Delete Task",
        text: 'Are you sure to delete this tasks?',
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
      if(result.value){
        phase.tasks.splice(t_index, 1)
        this.updateChecklist ()
      }
    },
    viewChecklist () {
      this.formFlag = false
      if (this.moveTasksFlag && this.selectedTaskIndex) {
        this.selectedPhase.tasks.splice(this.selectedTaskIndex, 0, this.selectedTask)
        this.selectedTaskIndex = null
        this.selectedTask = null
      }
      this.moveTasksFlag = false
      this.newTask = {
        type: 'normal',
        answerType: 'simple',
        text: ''
      }
    },
    addTask (phase, t_index) {
      this.formFlag = true
      this.newTask.phase = phase
      this.newTask.action = 'add'
      this.newTask.isChild = false
      if (t_index || t_index === 0) {
        this.newTask.t_index = t_index
        this.newTask.isChild = true
      }
    },
    editTask (phase, t_index) {
      this.formFlag = true
      this.newTask.phase = phase
      this.newTask.t_index = t_index
      this.newTask.action = 'edit'
      this.newTask.text = phase.tasks[t_index].text
      this.newTask.type = (phase.tasks[t_index].heading) ? 'heading' : 'normal'
      this.newTask.isChild = (phase.tasks[t_index].pl)? phase.tasks[t_index].pl : false
      this.newTask.answerType = (phase.tasks[t_index].type)? phase.tasks[t_index].type : 'simple'
    },
    submit () {
      if (!this.newTask.text || this.newTask.text === '') {
        return
      }
      this.loading = true
      let newTaskObject = {
        heading: this.newTask.type === 'heading',
        pl: this.newTask.isChild && this.newTask.type === 'normal',
        type: this.newTask.answerType,
        text: this.newTask.text,
        completed: false,
        reviewed: false,
        completedBy: '',
        reviewedBy: '',
        comments: []
      }
      if (this.newTask.action === 'add') {
        if (this.newTask.t_index || this.newTask.t_index === 0) {
          this.newTask.phase.tasks.splice(this.newTask.t_index + 1, 0, newTaskObject)
        } else {
          this.newTask.phase.tasks.push(newTaskObject)
        }
      } else if (this.newTask.action === 'edit') {
        this.newTask.phase.tasks[this.newTask.t_index] = newTaskObject
      }
      this.loading = false
      this.formFlag = false
      this.newTask = {
        type: 'normal',
        answerType: 'simple',
        text: ''
      }
      this.updateChecklist ()
    },
    async updateChecklist () {
      this.loading = true
      await db.collection('permissions').doc('migration-checklist').update({
          checklist: this.checklist,
      })
      await this.addLog({
        message: `User has updated migration checklist.`,
        level: "info"
      })
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">

  table{
    tr {
      .w-170 {
        width: 180px;
      }
      td {
        /deep/  p {
          margin: 0 !important;
        }
      }
    }
  }
  .cf-status-icons {
    i {
      font-size: 25px;
      margin: 0 !important;
      &.disabled {
        color: #7E7E7E;
      }

      &.enabled {
        color: #47f260;
      }

      &.yellow {
        color: #f2b61d;
      }
      &:hover{
        background-color:transparent !important;
        color: currentColor !important;
      }
    }
  }
</style>
